<template>
  <div class="card card-custom gutter-b" v-loading="loading">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Danh sách ca thi</h3>
      </div>
    </div>
    <div class="card-body">
             <div class="grid-filter">
         <div class="display-flex-column">
           <span>Mã ca thi</span>
           <el-input 
               v-model="filters.exam_shift_code" 
               placeholder="Nhập mã ca thi" 
               style="width: 100%" 
               clearable 
               @input="handleSearch()" 
               @clear="handleSearch()"
           >
             <i slot="prefix" class="el-input__icon el-icon-search"></i>
           </el-input>
         </div>
         <div class="display-flex-column">
           <span>Ngày thi</span>
           <el-date-picker
               v-model="filters.date" type="daterange"
               start-placeholder="Ngày" end-placeholder="Ngày" style="width: 100%"
               format="dd-MM-yyyy" value-format="yyyy-MM-dd"
               @change="handleSearch()"
           />
         </div>
         <div class="display-flex-column">
           <span>Loại ca thi</span>
           <el-select v-model="filters.type" placeholder="Chọn loại ca thi" style="width: 100%" @change="handleSearch()" clearable>
             <el-option :key="item.id" v-for="item in examScheduleTypes" :label="item.name" :value="item.id"/>
           </el-select>
         </div>
         <div class="display-flex-column">
           <span>Nhân sự coi thi</span>
           <el-select
               v-model="filters.supervisor" clearable filterable
               reserve-keyword placeholder="Chọn nhân sự coi thi" @change="handleSearch()"
           >
             <el-option
                 v-for="user in supervisors"
                 :key="user.id"
                 :label="user.id + 100000+  ' - ' + user.name"
                 :value="user.id"
             >
             </el-option>
           </el-select>
         </div>
       </div>
      <!-- Bảng -->
      <table class="table table-bordered table-hover">
        <thead class="thead-light">
        <tr>
          <th>Mã ca thi</th>
          <th>Thời gian thi</th>
          <th>Trung tâm</th>
          <th>Lớp học</th>
          <th>Buổi thi</th>
          <th>Loại bài thi</th>
          <th>Sĩ số</th>
          <th>Nhân sự coi thi</th>
          <th style="text-align: center">Trạng thái ĐK</th>
          <th style="text-align: center">Hành động</th>
        </tr>
        </thead>
        <tbody v-if="examShifts.length === 0">
        <tr>
          <td colspan="10" style="text-align: center">Không có dữ liệu</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr v-for="shift in examShifts" :key="shift.code">
          <td>{{ shift.code }}</td>
          <td>{{ shift.time }}</td>
          <td>{{ shift.center }}</td>
          <td>{{ shift.classroomName }}</td>
          <td>{{ shift.examName }}</td>
          <td>{{ shift.type }}</td>
          <td>{{ shift.students }}</td>
          <td>{{ shift.supervisor }}</td>
          <td style="text-align: center">
            <el-switch
              v-model="shift.isActive"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :loading="shift.toggling"
              @change="toggleShiftStatus(shift)"
            />
          </td>
          <td>
            <div style="display: flex; justify-content: center">
              <el-button v-if="shift.isShowEdit" title="Sửa" class="btn btn-xs btn-icon  btn-outline-primary" @click="openEditModal(shift)">
                <i class="el-icon-edit"></i>
              </el-button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <!-- Phân trang -->
      <div class="edu-paginate mx-auto text-center">
        <paginate
            v-model="page"
            :page-count="last_page"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :page-link-class="'page-link'"
            :page-class="'page-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
        />
        <div class="mt-2 text-right text-muted">Tổng số bản ghi: {{ total }}</div>
      </div>
    </div>
    <EditExamShiftModal
        :visible.sync="modalVisible"
        :form="selectedShift"
        :staff-list="supervisors"
        @submit="handleUpdate"
        @edit="getExamShift()"
    />
  </div>
</template>

<script>
import {GET_DETAIL_EXAM_SHIFTS, GET_EXAM_SHIFTS, GET_MARK_ALL_ADMIN, TOGGLE_EXAM_SHIFT} from "@/core/services/store/marking/admin.module";
import moment from 'moment'
import EditExamShiftModal from "@/view/pages/marking-exam/ExamShifts/EditExamShiftModal.vue";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {examScheduleTypes} from "@/common/define";

export default {
  components: {EditExamShiftModal},
  name: 'ExamShifts',
  data() {
    return {
      page: 1,
      perPage: 20,
      last_page: 1,
      total: 0,
      examShifts: [],
      filters: {
         exam_shift_code: '',
         date: [],
         type: null,
         supervisor: null
       },
      supervisors: [],
      modalVisible: false,
      selectedShift: {},
      staffList: [],
      loading: true,
      loadingSearch: false,
      examScheduleTypes,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Danh sách ca thi", name: 'exam-shifts'},
      {title: "Coi thi - Chấm thi"},
    ]);
    this.getExamShift()
    this.getMarkAllAdmin()
  },
  methods: {
    getMarkAllAdmin() {
      this.$store.dispatch(GET_MARK_ALL_ADMIN).then((data) => {
        this.supervisors = data.data.map((admin) => {
          return {
            id: admin.id,
            name: admin.user_name,
            userId: admin.user_id
          }
        })
      })
    },

    getExamShift() {
      this.getParams()
      this.callApi()
    },

    async handleSearch() {
      this.page = 1
      await this.queryFilterExamList()
      this.getExamShift()
    },

    callApi() {
       this.loading = true
       const params = {
         page: this.page,
         exam_date: this.filters.date,
         exam_type: this.filters.type,
         admin_profile_id: this.filters.supervisor
       }
       
       // Chỉ thêm mã ca thi vào params nếu có giá trị
       if (this.filters.exam_shift_code && this.filters.exam_shift_code.trim()) {
         params.exam_shift_code = this.filters.exam_shift_code.trim()
       }
      this.$store.dispatch(GET_EXAM_SHIFTS, params).then((res) => {
        const rawData = res.data || []
        this.examShifts = rawData.map((item) => {
          return {
            code: item.exam_shift_code,
            time: this.formatTimeRange(item.exam_time, item.exam_date),
            center: item?.center?.name,
            type: this.mapExamType(item.exam_type),
            students: `${item?.registration_count} / ${item?.max_slots ?? 0}`,
            classroomName: item?.classroom_name ?? '',
            examName: item?.exam_session_name ?? '',
            supervisor: item?.adminProfile?.user_name || 'Chưa phân công',
            id: item?.id,
            isShowEdit: this.checkShowEdit(item.exam_time, item.exam_date),
            isActive: item?.is_active == 1 ?true: false,
            toggling: false
          }
        })
        this.last_page = res?.pagination?.last_page
        this.total = res.pagination.total
      }).finally(() => {
        this.loading = false
      })
    },
    clickCallback(page) {
      this.page = page
      this.getExamShift()
    },
    mapExamType(type) {
      return this.examScheduleTypes.find(item => item.id === Number(type))?.name ?? 'Không rõ'
    },
    formatTimeRange(examTime, date) {
      if (examTime && date) {
        return `${moment(examTime, 'HH:mm:ss').format('HH:mm')} ${moment(date).format('DD-MM-YYYY')}`
      } else {
        return ''
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`
    },
    openEditModal(shift) {
      if (!shift.isActive) {
        this.$notify({
          title: 'Lỗi',
          message: 'Ca thi chưa được đăng ký, không thể sửa',
          type: 'error'
        });
        return
      }
      this.loading = true
      this.$store.dispatch(GET_DETAIL_EXAM_SHIFTS, shift.id).then((data) => {
        this.selectedShift = {...data.data}
        this.modalVisible = true
      }).finally(() => {
        this.loading = false
      })
    },
    handleUpdate() {
      this.getExamShift()
      this.modalVisible = false
    },
    checkShowEdit(examTime, examDate) {
      if (examTime && examDate) {
        const fullExamDateTime = `${examDate.trim()} ${examTime.trim()}`;
        const examMoment = moment(fullExamDateTime, 'YYYY-MM-DD HH:mm:ss', true);
        const now = moment();
        if (!examMoment.isValid()) {
          return false;
        }
        return now.isBefore(examMoment);
      }
      return false;
    },

    toggleShiftStatus(shift) {
      const actionLabel = shift.isActive ? 'bật' : 'tắt';
      this.$confirm(
        `Bạn có chắc muốn ${actionLabel} đăng ký cho ca thi <b>${shift.code}</b>?`,
        'Xác nhận',
        {
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Hủy',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        shift.toggling = true;
        this.$store.dispatch(TOGGLE_EXAM_SHIFT, shift.id)
          .then(() => {
            this.$notify({
              title: 'Thành công',
              message: `Chuyển trạng thái thành công`,
              type: 'success'
            });
          })
          .catch(() => {
            // Revert on error
            shift.isActive = !shift.isActive;
            this.$notify({
              title: 'Lỗi',
              message: 'Không thể thay đổi trạng thái. Vui lòng thử lại.',
              type: 'error'
            });
          })
          .finally(() => {
            shift.toggling = false;
          });
      }).catch(() => {
        // Revert switch if user cancels
        shift.isActive = !shift.isActive;
      });
    },

         getParams() {
       const query = this.$route.query
       this.filters.exam_shift_code = query.exam_shift_code || ''
       this.filters.date = query.exam_date
       this.filters.type = query.exam_type !== undefined && query.exam_type !== null && query.exam_type !== '' ? +query.exam_type : null;
       this.filters.supervisor = query.admin_profile_id
     },

         async queryFilterExamList() {
       await this.$router.push({
         name: 'ExamShifts',
         query: {
           exam_shift_code: this.filters.exam_shift_code,
           exam_date: this.filters.date,
           exam_type: this.filters.type,
           admin_profile_id: this.filters.supervisor
         },
       })
     },
  }
}
</script>

<style scoped>
.b-pagination {
  justify-content: center;
}

.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}

.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
  .grid-filter {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px 30px;
  }
}
</style>
